<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>部门</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="部门编码:" prop="code">
                          <el-input
                            id="code"
                            :disabled="IsReadonlyCode"
                            v-model="SelectData.code"
                            clearable
                          />
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="所属公司:" prop="companyId">
                          <el-select
                            v-model="SelectData.companyId"
                            placeholder="所属公司"
                            :disabled="OpStatus != 'AddParent'"
                          >
                            <el-option
                              v-for="item in CompanyList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="部门名称:" prop="name">
                          <el-input
                            id="name"
                            v-model="SelectData.name"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row  :gutter="20" class="row-bg">
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="角色:" prop="roleId">
                          <el-select
                            v-model="SelectData.roleIds"
                            placeholder="角色"
                            multiple
                            filter
                          >
                            <el-option
                              v-for="item in RoleList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import { ModifyDepartment, AddDepartment } from "@api/Company/ApiDepartment";

import { GetDataCompanyList } from "@api/Company/ApiCompany";

import { GetDataRoleList } from "@api/Company/ApiRole";

import { GetDataDepartmentRoleList } from "@api/Company/ApiDepartmentRole";

import Enumerable from "linq";

export default {
  name: "DepartmentEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      CompanyList: [],
      RoleList: [],
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        pageSize: 1000,
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(row, type) {
      //debugger;
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.IsReadonlyCode = true;
      _this.SelectData = {};

      _this.loadData_Company();
      _this.loadData_Role();

      //增加子节点
      if (type == "Add") {
        _this.IsReadonlyCode = false;
        _this.SelectData.level = row.level + 1;
        _this.SelectData.parentId = row.id;
        _this.SelectData.companyId = row.companyId;
        return;
      }
      //增加根节点
      if (type == "AddParent") {
        _this.IsReadonlyCode = false;
        _this.SelectData.level = 1;
        _this.SelectData.parentId = 0;

        return;
      }
      _this.SelectData = row;
      // 获取当前部门角色
      let PageQuery = {
        queryModel: {
          departmentId: row.id,
        },
        pageindex: 1,
        pageSize: 1000,
      };
      GetDataDepartmentRoleList(PageQuery).then(function ({ entities }) {
        _this.SelectData.roleIds = Enumerable.from(entities).select(x => x.roleId).toArray();
      });
    },
    /**
     * 获取公司
     */
    loadData_Company() {
      const _this = this;
      GetDataCompanyList(_this.PageQuery).then(function (data) {
        _this.CompanyList = data.entities;
      });
    },
    /**
     * 获取角色
     */
    loadData_Role() {
      const _this = this;
      GetDataRoleList(_this.PageQuery).then(function (data) {
        _this.RoleList = data.entities;
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;
      if (!this.validate()) return;
      if (_this.OpStatus == "Add" || _this.OpStatus == "AddParent") {
        AddDepartment(_this.SelectData)
          .then(function (data) {
            _this.$message.success("新增成功!");
            _this.$emit("handle-confirm");
          })
          .catch((x) => {
            _this.$message.error(x.message);
          });
      } else if (_this.OpStatus == "Modify") {
        ModifyDepartment(_this.SelectData).then(function (data) {
          _this.$message.success("编辑成功!");
          _this.$emit("handle-confirm");
        });
      }
    },
    validate() {
      if (!this.SelectData.code || this.SelectData.code == "") {
        this.$message.error("代码是必须的!");
        return false;
      }
      if (!this.SelectData.name || this.SelectData.name == "") {
        this.$message.error("名称是必须的!");
        return false;
      }
      if (!this.SelectData.companyId || this.SelectData.companyId == "") {
        this.$message.error("所属公司是必须的!");
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.formtable {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.tyyzm ::v-deep .el-form-item__label {
  width: 120px;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  // margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
